<template>
  <div id="main">
    <div class="main_top"></div>
    <div class="details_title">Order details</div>
    <div class="details_list">
      <div class="orderdetails_type">
        <div class="list_type list_exp" v-if='Unstored'>Unstored</div>
        <div class="list_type list_store">Arriving</div>
      </div>
      <div class="details_input">
        <div class="list_title">Order ID</div>
        <div class="list_input"><span>
            13243125655234
          </span></div>
      </div>
      <div class="details_input">
        <div class="list_title">Logistics</div>
        <div class="list_input"><span>
            4PX
          </span></div>
      </div>
      <div class="details_input">
        <div class="list_title">Recipient</div>
        <div class="list_input"><span>
            Alvin Lee 871265264
          </span></div>
      </div>
    </div>
    <button class="details_bt_w" @click="back">Back</button>
    <button class="details_bt_b" @click="to_index">Scan to store</button>
    <bottom></bottom>
  </div>

</template>

<script>
import bottom from '../Bottom.vue'
export default {
  name: 'DetailsArriving',
  components: {bottom},
  beforeCreate: function () {
    document.getElementsByTagName('body')[0].style = 'background-color: #f8f8f8;'
  },
  methods: {
    to_index () {
      this.$router.push({
        path: '/index'
      })
    },
    to_OrderDetails () {
      this.$router.push({
        path: '/order/details',
        query: {
          list_id: 3,
          type: 'Returned'
        }
      })
    },
    back () {
      this.$router.go(-1)
    }
  },
  data () {
    if (this.$route.query.Unstored) {
      this.Unstored = true
    }
    return {
      Unstored: this.Unstored
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" src="../../assets/css/order/detailsarriving.css" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Order/DetailsArriving.vue